import { last, sift } from "radash";

export const listAsText = (elements: string[], and = "&") =>
  sift([elements.slice(0, -1).join(", "), last(elements)]).join(` ${and} `);
